import React from "react";
import { Button, Table, useDataTableColumnCount } from "@sscs/ui";
import styles from "./fetchMoreData.module.scss";

type FetchMoreDataProps = {
  id: string;
  itemsCount: number;
  itemName: string;
  onRefetch: () => void;
};

const FetchMoreData = ({
  id,
  itemsCount,
  itemName,
  onRefetch,
}: FetchMoreDataProps): React.JSX.Element => {
  const colSpan = useDataTableColumnCount() ?? 1;

  return (
    <Table.Row className={styles.root}>
      <Table.Cell colSpan={colSpan}>
        <Button variant="text" size="small" id={id} onClick={onRefetch}>
          Show {itemsCount.toLocaleString()} {itemName}
          {itemsCount !== 1 ? "s" : ""} uploaded by other user(s)
        </Button>
      </Table.Cell>
    </Table.Row>
  );
};

export default FetchMoreData;
